import dayjs from "global/dayjs";
import type { ChatSummary } from "app/modules/aiAssistant/AIAssistantSlice";

type ChatHistoryGroup = { label: string; chats: ChatSummary[] };

const PREVIOUS_DAYS_IN_RECENT_GROUP = 7;

export const filterChatsByName = (chats: ChatSummary[], search: string) => {
  const term = search.trim().toLowerCase();
  if (term === "") return chats;
  return chats.filter((c) => c.chatName.toLowerCase().includes(term));
};

export const groupChatsByDate = (chats: ChatSummary[], now: dayjs.Dayjs = dayjs()): ChatHistoryGroup[] => {
  const today = now.startOf("day");
  const groups: ChatHistoryGroup[] = [
    { label: "Today", chats: [] },
    { label: "Yesterday", chats: [] },
    { label: `Previous ${PREVIOUS_DAYS_IN_RECENT_GROUP} days`, chats: [] },
    { label: "Older", chats: [] },
  ];
  const [todayGroup, yesterdayGroup, recentGroup, olderGroup] = groups;

  chats.forEach((chat) => {
    const startedAt = chat.startedAt ? dayjs(chat.startedAt) : undefined;

    if (startedAt === undefined || !startedAt.isValid()) {
      olderGroup.chats.push(chat);
    } else if (startedAt.isSameOrAfter(today)) {
      todayGroup.chats.push(chat);
    } else if (startedAt.isSameOrAfter(today.subtract(1, "day"))) {
      yesterdayGroup.chats.push(chat);
    } else if (startedAt.isSameOrAfter(today.subtract(PREVIOUS_DAYS_IN_RECENT_GROUP, "day"))) {
      recentGroup.chats.push(chat);
    } else {
      olderGroup.chats.push(chat);
    }
  });

  return groups.filter((g) => g.chats.length > 0);
};
